import { IconButton, TabsWrapper } from 'src/styles/button.style';
import styled from 'styled-components';

type DynamicSizeProps = {
    containerWidth?: number;
};
export const TankPlanTopMenuContainer = styled.div<DynamicSizeProps>`
    display: flex;
    padding: 0 0 0 5px;
    width: ${(props) => (props.containerWidth ? props.containerWidth + 'px' : '100%')};
`;

export const ExpandTopMenuButton = styled.button`
    flex: 0 0 auto;
    padding: 4px 10px;
    height: 29px;
    border: 1px solid ${({ theme }) => theme.colors.border.ddd};
    background: ${({ theme }) => theme.colors.background.fafafa};
    border-radius: 4px;
    font-size: 0.75rem;
    left: 5px;
    box-shadow: ${({ theme }) => theme.colors.shadow.ccc} 0px 2px 8px -1px;
    z-index: 1;
`;

export const ExpandTopMenuPanel = styled.div`
    flex: 0 0 auto;
    padding: 5px 5px;
    border-radius: 4px;
    font-size: 0.75rem;
    height: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 4;
`;

export const FilterButton = styled(IconButton)`
    background: ${({ theme }) => theme.colors.background.white};
    font-size: 1rem;
    cursor: pointer;
    padding: 3px 6px;
    width: 40px;
    height: 30px;
    border: 1px solid ${({ theme }) => theme.colors.border.ccc};
`;

export const ExpandTopMenuPanelItemSelect = styled.div`
    font-size: 0.7rem;
    display: flex;
    position: relative;
`;

export const ExpandTopMenuPanelItem = styled.button`
    padding: 0px 15px;
    font-size: 0.8rem;
    height: 30px;
    margin: 0 0 0 5px;
    font-weight: 500;
    border: 1px solid ${({ theme }) => theme.colors.border.ddd};
`;

type TankPlanTopMenuInvalidItemProps = {
    type: 'warning' | 'invalid';
};
export const InvalidTankplan = styled.div<TankPlanTopMenuInvalidItemProps>`
    height: 28px;
    margin: 0px 0px 0px 5px;
    color: ${(props) => (props.type === 'invalid' ? props.theme.colors.text.error : props.theme.colors.text.softError)};
    font-weight: 600;
    font-size: 0.9rem;
    line-height: 1.6rem;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.background.white};
    user-select: none;
    display: flex;
    align-items: center;
    .show-text{
        display: none;
    }

    .icons-wrapper{
        border-radius: 4px;
    }

    @media (min-width: 1600px) {
        .show-text{
            display: block;
            padding: 0 5px;
                background: #ff0000;
                color: #fff;
                border-radius: 4px;
                margin: 0 1px;
        }
    }
`;

export const IconsWrapper = styled.span<TankPlanTopMenuInvalidItemProps>`
    padding: 1px 5px 1px 10px;
    display: inline-block;
    background: ${(props) => (props.type === 'invalid' ? props.theme.colors.text.error : props.theme.colors.text.softError)};
    color: ${({ theme }) => theme.colors.text.white};
    border-radius: 4px;
    margin: 0px 1px;
    .hard-rule-warning-icon, .soft-rule-warning-icon {
        color: #fff;
    }
    &:hover {
        background: #ccc;           
        color: ${({ theme }) => theme.colors.text.white};
        cursor: pointer;
    }
`;

export const StowageTabsWrapper = styled(TabsWrapper)`
    .tabs-button {
        border: 1px solid ${({ theme }) => theme.colors.border.dashed};
        padding: 4px 10px;
        height: 30px;
        color: ${({ theme }) => theme.colors.text.tabText};
        min-width: 4rem;
        font-size: 0.8rem;
        justify-content: center;
        margin: 0px;
        &.first {
            border-radius: 3px 0px 0px 3px;
        }
        &.last {
            border-radius: 0 3px 3px 0;
        }
    }
`;

export const BottomTankPlanMenuWrapper = styled.span`
    width: 0px;
    position: relative;
`;
